/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('token', [
  'getTokens',
]);

function getTokens(query) {
  return createAPIAction(
    types.getTokens,
    {
      endpoint: 'tokens',
      method: 'GET',
      query,
    })();
}

export default {
  getTokens,
};




// WEBPACK FOOTER //
// ./src/redux/actions/token.js